import * as z from 'zod';
import { VALIDATION_MESSAGES } from '@/features/forms/validation';

const validationScheme = z
  .object({
    senderName: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    senderEmail: z.string().email({ message: VALIDATION_MESSAGES.email }),
    receiverName: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    receiverEmail: z.string().email({ message: VALIDATION_MESSAGES.email }),
    message: z.string(),
  })
  .required();

export type FormEmailShareDataType = z.infer<typeof validationScheme>;

export default validationScheme;
